module.exports = __webpack_public_path__ + "static/banner-1-music-school-6a8c664788d2da0fb1c168752d3a2615.jpg";